import React from 'react';
import { Link } from 'react-router-dom';
import { PolicyLayout } from '../../components/ui/PolicyLayout';
import { WarrantyTag } from '../../components/ui/WarrantyTag';
import { pricingConfig, warrantyConfig } from '../../data/pricing';
import { warrantySections } from '../../data/policies/warranty';
import { useLanguage } from '../../contexts/LanguageContext';
import { bundleName } from '../../utils/pricing';
export function Warranty() {
  const {
    lang
  } = useLanguage();
  const coverage = <>
      <table className="w-full text-left text-sm" data-id="element-1047" data-mp="3p3ativ58p28e">
        <tbody data-id="element-1048" data-mp="3p0evl6te6djy">
          <tr className="border-b mf-hairline" data-id="element-1049" data-mp="3l0e5uq0uefxl">
            <th scope="row" className="py-3 pr-4 font-medium text-white" data-id="element-1050" data-mp="3kz31op3hj65y">Individual lights</th>
            <td className="py-3" data-id="element-1051" data-mp="3g0rsmgl0kzos"><WarrantyTag tier={warrantyConfig.individual} data-id="element-1052" data-mp="3g19ubsqg4643" /></td>
          </tr>
          {pricingConfig.bundles.filter(b => b.qty > 1).map(b => <tr key={b.id} className="border-b mf-hairline" data-id="element-1053" data-mp="24m4sss21wdm2">
              <th scope="row" className="py-3 pr-4 font-medium text-white" data-id="element-1054" data-mp="24oqyem5dsj1n">{bundleName(b, lang)}</th>
              <td className="py-3" data-id="element-1055" data-mp="1jmha5jsptmzh"><WarrantyTag tier={b.warranty} data-id="element-1056" data-mp="1on4whs601fnd" /></td>
            </tr>)}
        </tbody>
      </table>
      <p data-id="element-1057" data-mp="1ao590nu836ss">
        Coverage starts on the date your order is delivered. Need help now?{' '}
        <Link to="/warranty-claim" className="text-ice hover:underline" data-id="element-1058" data-mp="1fmgll6bwjvep">Start a warranty claim</Link>.
      </p>
    </>;
  return <PolicyLayout title="Warranty Information" lead="Professional-grade lighting deserves professional-grade support. Here is exactly what the M1 PRO Limited Warranty covers." sections={[{
    id: 'coverage',
    heading: 'Coverage by purchase',
    body: coverage
  }, ...warrantySections]} data-id="element-1059" data-mp="10x0v7rga9rzj" />;
}